import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvLabelledFieldProps {
  label: string;
  children: ReactNode;
  className?: string;
}

const OvLabelledField: FC<OvLabelledFieldProps> = ({
  label,
  children,
  className,
}) => (
  <Field className={className}>
    <Label>{label}</Label>
    <Value>{children}</Value>
  </Field>
);

export default OvLabelledField;

const Field = styled.div`
  min-width: 0;
`;

const Label = styled.dt`
  margin-bottom: 0.3125rem;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
  line-height: 1rem;
`;

const Value = styled.dd`
  margin: 0;
  font-size: ${Variables.fontSizes.MEDIUM};
  line-height: ${Variables.lineHeights.LARGE};
  overflow-wrap: break-word;
`;
